import { render, staticRenderFns } from "./ProfileStats.vue?vue&type=template&id=85cbbac4&scoped=true"
import script from "./ProfileStats.vue?vue&type=script&lang=js"
export * from "./ProfileStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cbbac4",
  null
  
)

export default component.exports